import { ErrorResponse } from 'api/types/errors';
import { useMutation, useQuery } from 'react-query';
import { OutgoingOrganizationMemberDto } from 'api/dtos/organizations/members';
import {
  joinOrganization as joinOrganizationService,
  exportOrganizationMembersCSV
} from 'api/services/organizations/members';

export function joinOrganization() {
  return useMutation<
    OutgoingOrganizationMemberDto,
    ErrorResponse,
    {
      organizationId: string;
    }
  >(joinOrganizationService);
}

export function useExportOrganizationMembersCSV({
  organizationId,
  enabled = false
}: {
  organizationId: string;
  enabled?: boolean;
}) {
  return useQuery<Blob, ErrorResponse>(
    ['exportOrganizationMembersCSV', { organizationId }],
    () => exportOrganizationMembersCSV(organizationId),
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
}
